'use client';

import { useIsShowingPopup } from '@wwe-portal/web/providers/stores/global-search-store';

export const GlobalSearchOverlay = () => {
  const showPopup = useIsShowingPopup();
  if (!showPopup) return null;
  return (
    <div className="bg-back800 z-globalSearchInput pointer-events-auto fixed inset-0 top-[60px] opacity-95 xl:left-[240px] xl:right-[280px] xl:top-[70px]" />
  );
};
